<!-- `[style.bottom.px]` raises the bottom edge by however much of the page footer
     is on screen, so the panel spans header -> footer and never covers the footer
     links (measured live — see `footerInset`). Desktop only: the mobile panel is a
     full-screen overlay, with no page showing to tuck under. -->
<div
  *ngIf="open"
  class="orbi-panel"
  [class.orbi-panel--desktop]="isDesktop"
  [class.orbi-panel--mobile]="!isDesktop"
  [style.bottom.px]="isDesktop ? footerInset : null"
  role="region"
  aria-labelledby="orbi-panel-title"
>
  <header class="orbi-panel__header">
    <!-- New conversation is struck out + disabled while the session is locked
         (PCSA-13170). `disabled` + `aria-disabled` make the state SR-detectable,
         not visual-only; the click handler also no-ops. History (below) stays
         ENABLED while locked so the user can browse past conversations read-only
         (mobile parity) — the list itself grays out + disables the others. -->
    <button
      type="button"
      class="orbi-panel__icon-btn material-icons-round"
      [class.orbi-panel__icon-btn--locked]="locked"
      [attr.aria-disabled]="locked"
      [attr.aria-label]="locked ? 'Start a new conversation, unavailable' : 'Start a new conversation'"
      (click)="onNewConversation()"
    >
      add
    </button>
    <button
      type="button"
      class="orbi-panel__icon-btn material-icons-round"
      [class.orbi-panel__icon-btn--active]="historyActive"
      [attr.aria-label]="historyActive ? 'Close conversation history' : 'Open conversation history'"
      (click)="onHistory()"
    >
      history
    </button>
    <h2 #panelHeading id="orbi-panel-title" class="orbi-panel__title" tabindex="-1">{{ title }}</h2>
    <span class="orbi-panel__header-spacer"></span>
    <button
      type="button"
      class="orbi-panel__icon-btn orbi-panel__icon-btn--minimize material-icons-round"
      aria-label="Minimize conversation panel"
      (click)="onClose()"
    >
      remove
    </button>
  </header>

  <!-- Content slot: initial state (13159) / message thread (13160) land here.
       The thread fills the body (feed grows + scrolls, disclaimer + input pin to
       the bottom per Figma). -->
  <div class="orbi-panel__body">
    <ng-content></ng-content>
  </div>

  <!-- Response-feedback bottom sheet + success toasts (PCSA-13169 rename/delete,
       PCSA-13171 feedback). Absolutely positioned within the panel: the sheet
       docks to the bottom, toasts to the top-right. (The footer disclaimer moved
       into the thread, above the input — Figma layout, PCSA-13312.) -->
  <patient-ui-orbi-feedback-sheet></patient-ui-orbi-feedback-sheet>
  <patient-ui-orbi-toasts aria-live="polite" aria-atomic="true"></patient-ui-orbi-toasts>
</div>
